import {spacing, padding, gap} from './tokens/primitives/spacing'

const themeSpacing = {
    space: {
        spacing,
        space: {
            padding,
            gap,
        },
    },
}

export default themeSpacing
